const config = require('appConfig');

export const stripeKey = config.stripeKey;

import React, {Component, PropTypes} from 'react';
import {
  Col,
  Modal,
} from '@sketchpixy/rubix';
import styled from 'styled-components';

import {Elements, StripeProvider} from 'react-stripe-elements';
import StripeInputForm from "./EditCard/StripeInputForm";

const RootContainer = styled.div`
`;


class EditCardModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stripe: null,
      contractId: -1,
      totalAmount: 0,
    };
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({stripe: window.Stripe(stripeKey)});
    }

    if (this.props.contract) {
      const contract = this.props.contract;

      this.setState({
        contractId: contract.contractId,
      });
    }
  }

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Card</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{height: '300px'}}>
            <StripeProvider stripe={this.state.stripe}>
              <RootContainer>
                <Col className="m-auto" xs={12} lg={12}>
                  <Elements>
                    <StripeInputForm
                        contractId={this.state.contractId}
                        closeModal={this.props.closeModal}
                    />
                  </Elements>
                </Col>
              </RootContainer>
            </StripeProvider>
          </Modal.Body>
        </Modal>
    );
  }
}

EditCardModal.propTypes = {
  contract: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default EditCardModal;



// WEBPACK FOOTER //
// ./src/routes/patient/Modal/EditCardModal.js